import { DefaultDatasetDurationLimiter } from "@/services/license/license-limiters/dataset-duration-limiters/default-dataset-duration-limiter";

export class EmptyDatasetDurationLimiter extends DefaultDatasetDurationLimiter {
  getUniqueLimit(userId: string): Promise<number | null> {
    return Promise.resolve(null);
  }
}
